module.exports = "/_next/static/images/Confetti-Group-38499769d5c93082323a7df8e4244f23.png";